import React from "react"

import {Hue} from "./Hue"

import {AnyColor, ColorModel, ColorPickerBaseProps} from "../types"
import {useColorManipulation} from "../hooks/useColorManipulation"

interface Props<T extends AnyColor> extends Partial<ColorPickerBaseProps<T>> {
    colorModel: ColorModel<T>;
}

export const ColorPickerStruct = <T extends AnyColor>({
    colorModel,
    color = colorModel.defaultColor,
    height,
    width,
    onChange
}: Props<T>): JSX.Element => {

    const [hsva, updateHsva] = useColorManipulation<T>(colorModel, color, onChange)
    return <div className="position-relative" style={{height: height, width: width}}>
        <Hue hue={hsva.h} onChange={updateHsva} height={height} width={width} />
    </div>
}
